import React from 'react';
import cx from 'classnames';
import s from './s.module.less';

export interface CardRadioOption {
    value: string;
    title: React.ReactNode;
    desc?: React.ReactNode;
    // Recommended 绿色胶囊
    recommended?: boolean;
    // 其它胶囊文案（如 Default，紫色 muted 样式）
    tag?: string;
}

type Props = {
    // 由 Form.Item 注入
    value?: string;
    onChange?: (v: string) => void;
    options: CardRadioOption[];
    // 两选项横排（原型 addressChoice / claimScope / claimStartMode）
    horizontal?: boolean;
};

// 卡片式单选（原型 .ibbw-radio-card）：圆点 + 标题（可带胶囊）+ 描述
export default function CardRadioGroup({ value, onChange, options, horizontal }: Props) {
    return (
        <div className={cx(s.radioCards, horizontal && s.horizontal)}>
            {options.map((o) => (
                <button
                    key={o.value}
                    type="button"
                    className={cx(s.radioCard, value === o.value && s.selected)}
                    onClick={() => onChange?.(o.value)}
                >
                    <span className={s.radioDot} aria-hidden />
                    <span className={s.radioBody}>
                        <span className={s.radioTitle}>
                            {o.title}
                            {o.recommended && <span className={s.recTag}>Recommended</span>}
                            {!o.recommended && o.tag && <span className={cx(s.recTag, s.muted)}>{o.tag}</span>}
                        </span>
                        {o.desc && <span className={s.radioDesc}>{o.desc}</span>}
                    </span>
                </button>
            ))}
        </div>
    );
}
